import React, { useState } from 'react'
import styled from 'styled-components'
import Container from '../container'
import ResponsiveFonts from '../responsiveFonts'
import LogoSource from '../../../../assets/logowhite.png'
import { HashLink } from 'react-router-hash-link'
import menu from './menu'
import { Grid, useMediaQuery } from '@material-ui/core'
import { Menu } from '@material-ui/icons'
import OptionsMobile from './optionsMobile'

const HeaderStyled = styled.header`
  background: var(--first);
  position: sticky;
  top: 0px;
  z-index: 9;
`

const HeaderInt = styled.div`
  height: 85px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #fff;
  font-family: 'imlmedium';
  @media screen and (max-width:1300px) {
    height: 80px;
  }
  @media screen and (max-width:700px) {
    height: 75px;
  }
  @media screen and (max-width:650px) {
    height: 60px;
  }
`
const Logo = styled.img`
  width: 200px;
  @media (max-width:1700px) {
    width: 180px;
  }
  @media (max-width:1400px) {
    width: 160px;
  }
  @media (max-width:900px) {
    width: 120px;
  }
  @media (max-width:50px) {
    width: 100px;
  }
`

const MenuStyled = styled(Menu)`
  color: var(--second);
`

const MenuItem = styled(HashLink)`
  text-align: center;
  display: block;
  line-height: 1.2em;
  :hover {
    text-decoration: none;
  }
  @media screen and (max-width:800px) {
    margin-left: .7em;
    font-size: .9em;
  }
`

const Header = props => {
  const isMobile = useMediaQuery('(max-width:650px)')
  const [isOpen, setOpen] = useState(false)

  const ToggleMenu = props => {
    setOpen(!isOpen)
  }

  const handleScroll = element => {
    try {
      window.scrollTo({ top: element.offsetTop - 100, behavior: 'smooth' })
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <HeaderStyled>
      <Container>
        <HeaderInt>
          <a href='https://www.laboratoriosiml.com/index.php'>
            <Logo src={LogoSource} />
          </a>
          {!isMobile && (
            <ResponsiveFonts>
              <Grid container alignItems='center'>
                {menu.map((menuItem, index) => {
                  const props = {}
                  if (menuItem.external) props.as = 'a'
                  if (menuItem.external) props.href = menuItem.path
                  else props.to = menuItem.path
                  return (
                    <Grid key={index} item xs>
                      <MenuItem {...props} smooth scroll={handleScroll}>
                        {menuItem.label}
                      </MenuItem>
                    </Grid>
                  )
                })}
              </Grid>
            </ResponsiveFonts>
          )}

          {isMobile && (
            <div>
              <MenuStyled onClick={ToggleMenu} />
              <OptionsMobile open={isOpen} onClose={ToggleMenu} />
            </div>
          )}
        </HeaderInt>
      </Container>
    </HeaderStyled>
  )
}

export default Header
